<template>
  <div>
    <div class="mt-0 pt-1"></div>
    <div class="small text-muted">
      <span class="text-teal" :class="{'pointer': edicao,'disabledClick': !edicao}" @click.prevent="editHashBIB">
        ({{ labelBib }})
        <i class="icon ml-1 far" :class="{'fa-angle-up' : envolvido.editandoHashBIB, 'fa-angle-down' : !envolvido.editandoHashBIB}"></i>
      </span>
    </div>

    <template v-if="envolvido.editandoHashBIB">
      <div class="w-100 mt-2 border-top border-gray pt-2"></div>

      <!-- Lista de consultas BIB -->
      <div v-for="(bib, idx) in consultasBib" :key="idx" class="mb-2 pb-2 border-bottom border-light">

        <!-- Linha do hash -->
        <div class="row gutters-xs align-items-end">
          <div class="col form-group mb-0">
            <label class="form-label form-label-xs">Hash da consulta BIB</label>
            <input
              type="text"
              :disabled="!edicao"
              v-model="bib.numero"
              placeholder="Hash da consulta BIB"
              class="form-control form-control-xs"
              @input="preencherDataAutomatica(bib)"
            />
          </div>
          <div class="col-auto" v-if="edicao">
            <button class="btn btn-outline-secondary btn-xs" @click.prevent="removerBib(idx)" type="button" title="Remover">
              <i class="fal fa-times"></i>
            </button>
          </div>
        </div>

        <!-- Alerta de divergência entre data manual e data extraída do número -->
        <div
          v-if="bib.numero && bib.dataAutomatica && bib.data && bib.data !== bib.dataAutomatica"
          class="alert alert-warning py-1 px-2 small mb-1 mt-1"
        >
          ⚠️ Data da consulta divergente do número do BIB. Verifique a data informada.
        </div>

        <!-- Campos: data, gratuito, lei11441 -->
        <div class="row gutters-xs mt-1 align-items-center">
          <div class="col-auto d-flex align-items-end pb-1" v-if="estaBibVencida(bib)" title="Esta consulta BIB ultrapassou o prazo de 30 dias corridos.">
            <i class="fas fa-exclamation-triangle text-warning fa-sm"></i>
          </div>
          <v-input class="col-4" type="date" label="Data da Consulta BIB" v-model="bib.data" :disabled="!edicao" />
          <v-input class="col-4" type="radio" label="Gratuito" v-model="bib.gratuito" :disabled="!edicao" />
          <div class="col-4 form-group mb-0">
            <label class="form-label form-label-xs">Consulta Ref. Lei 11.441/07</label>
            <input
              type="text"
              :disabled="!edicao"
              v-model="bib.lei11441"
              placeholder="Referência Lei 11.441/07"
              maxlength="27"
              class="form-control form-control-xs"
            />
          </div>
        </div>
      </div>

      <!-- Botão adicionar nova consulta -->
      <div v-if="edicao" class="mt-1">
        <button class="btn btn-outline-primary btn-xs" @click.prevent="adicionarBib" type="button" title="Adicionar nova consulta BIB">
          <i class="fal fa-plus mr-1"></i> Adicionar consulta BIB
        </button>
      </div>

      <div v-if="!edicao && consultasBib.length === 0" class="small text-muted fst-italic">
        Nenhuma consulta BIB informada.
      </div>
    </template>
  </div>
</template>

<script>
import Utils from "@/commons/Utils";

export default {
  name: "EnvolvidoBib",

  emits: ['toggle-bib'],

  props: {
    envolvido: { type: Object, required: true },
    edicao: { type: Boolean, default: false },
  },

  computed: {
    consultasBib() {
      return this.envolvido.consultasBib || [];
    },

    labelBib() {
      const bibs = this.consultasBib.filter(b => b.numero);
      if (!bibs.length) return 'Informar Hash da consulta BIB';
      if (bibs.length === 1) return `BIB: ${bibs[0].numero?.substring(0, 20)}...`;
      return `BIB: ${bibs.length} consulta(s)`;
    },
  },

  methods: {
    editHashBIB() {
      if (!this.edicao) return;
      this.$emit('toggle-bib', this.envolvido);
      this.$set(this.envolvido, 'editandoHashBIB', !this.envolvido.editandoHashBIB);
    },

    adicionarBib() {
      if (!this.envolvido.consultasBib) {
        this.$set(this.envolvido, 'consultasBib', []);
      }
      this.envolvido.consultasBib.push({ numero: null, data: null, gratuito: null, lei11441: null });
    },

    removerBib(idx) {
      this.envolvido.consultasBib.splice(idx, 1);
    },

    preencherDataAutomatica(bib) {
      const data = Utils.extrairDataConsultaBib(bib.numero);
      this.$set(bib, 'dataAutomatica', data);
      if (data && !bib.data) {
        this.$set(bib, 'data', data);
      }
    },

    estaBibVencida(bib) {
      if (!bib.data) return false;
      const dataConsulta = new Date(bib.data + 'T00:00:00');
      const limiteVencimento = new Date();
      limiteVencimento.setDate(limiteVencimento.getDate() - 30);
      limiteVencimento.setHours(0, 0, 0, 0);
      return dataConsulta < limiteVencimento;
    },
  },
};
</script>
